import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, Box, Button, CircularProgress, Typography } from '@mui/material';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import EditIcon from '@mui/icons-material/Edit';
import { QRCodeCanvas } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { apiService } from '../services/apiService';

const Success = () => {
    const { t, i18n } = useTranslation();
    const { userId } = useParams();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const qrCodeRef = useRef(null);

    useEffect(() => {
        const fetchUserById = async () => {
            try {
                const data = await apiService.getUserById(userId)
                if (!data) {
                    navigate('/');
                } else {
                    setUserData(data);
                }
            } catch (error) {
                console.error(t('error_get_user_by_slug'), error);
                navigate('/');
            } finally {
                setLoading(false);
            }
        };

        if (userId) fetchUserById();
    }, [userId, navigate]);

    const downloadQRCode = () => {
        const canvas = qrCodeRef.current.querySelector('canvas');
        const pngUrl = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.href = pngUrl;
        downloadLink.download = `QRCode.png`;
        downloadLink.click();
    };

    if (loading) {
        return (
            <Grid container display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <>
            <Header />
            <Grid container display="flex" justifyContent="center" alignItems="center" p={4}>
                <Grid item xs={12} sm={6} display="flex" flexDirection='column' alignItems="center">

                    <Typography component="h1" variant="h3" sx={{ fontWeight: 'bold', mb: 2 }} textAlign='center'>
                        {t('success_page_headline')}
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 2 }} textAlign='center'>
                        {t('success_page_subheadline')}
                    </Typography>

                    {/* QR Code com a referência */}
                    <Box ref={qrCodeRef} sx={{ my: 4 }}>
                        <QRCodeCanvas value={`https://withlove.page/u/${userData?.slug}`} marginSize={1} size={275} />
                    </Box>

                    <Grid
                        item
                        xs={12}
                        display='flex'
                        justifyContent='center'
                        flexDirection='column'
                        mb={4}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={downloadQRCode}
                            fullWidth
                            sx={{
                                borderColor: '#f03093',
                                boxShadow: 'none',
                                '&:hover': {
                                    boxShadow: 'none',
                                },
                                color: '#fff',
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                px: 3,
                                mb: 3
                            }}
                        >
                            {t('button_download_qr_code_label')}
                        </Button>


                        <Button
                            variant="contained"
                            component="span"
                            endIcon={<ExitToAppOutlinedIcon />}
                            onClick={() => navigate(`/u/${userData.slug}`)}
                            fullWidth
                            sx={{
                                borderColor: '#f03093',
                                boxShadow: 'none',
                                '&:hover': {
                                    boxShadow: 'none',
                                },
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                px: 3,
                                mb: 3
                            }}
                        >
                            {t('button_go_to_site_label')}
                        </Button>

                        <Button
                            variant="contained"
                            component="span"
                            endIcon={<EditIcon />}
                            onClick={() => navigate(`/${i18n.language}/edit/${userId}`)}
                            fullWidth
                            sx={{
                                borderColor: '#f03093',
                                boxShadow: 'none',
                                '&:hover': {
                                    boxShadow: 'none',
                                },
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                px: 3
                            }}
                        >
                            {t('button_edit_site_label')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Footer />
        </>
    );
};

export default Success;
